/* import __COLOCATED_TEMPLATE__ from './recent-orders.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const RecentOrders = templateOnlyComponent<Signature>();
export default RecentOrders;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::Shopify::RecentOrders': typeof RecentOrders;
    'inbox2/conversation-details-sidebar/sidebar-sections/shopify/recent-orders': typeof RecentOrders;
  }
}
